import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { useEditFormContext } from 'pages/formsCreate/context';
import { useStyles } from './styles';
import { Preview } from 'pages/formsCreate/Preview';
import { IQuestionnaireRequestData } from 'pages/formsCreate/types';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { IRouterProps } from 'pages/orderHistory';

export const PreviewButton = ({ router }: IRouterProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { button, icon } = useStyles();
  const { title, description, questionList: questions, newQuestionRequired, handleSubmitForm } = useEditFormContext();
  const toggleIsOpen = () => setIsOpen((prev) => !prev);

  const handlePreviewModal = () => {
    setIsOpen(!isOpen);
  };

  const form: Pick<IQuestionnaireRequestData, 'title' | 'description' | 'questions' | 'required'> = {
    title,
    questions,
    description,
    required: newQuestionRequired
  };

  const Icon = isOpen ? VisibilityOff : Visibility;

  return (
    <>
      {isOpen && <Preview form={form} router={router} onClose={handlePreviewModal} onSave={handleSubmitForm} />}
      <Button className={button} onClick={toggleIsOpen}>
        <Icon className={icon} />
        Ver formulário
      </Button>
    </>
  );
};
